import React from 'react';
import AcademyHeader from '../../../components/LP/AcademyHeader';
import LPFooter from '../../../components/LP/LPFooter';
import SEO from '../../../components/SEO/SEO';

const CancellationPolicyPage = () => {
  return (
    <div className="min-h-screen flex flex-col font-noto bg-lp-cream text-lp-charcoal">
      <SEO
        title="キャンセルポリシー｜SrWithアカデミー"
        description="SrWithアカデミーのキャンセルポリシーについてご案内します。"
      />

      <AcademyHeader />

      <main className="flex-grow pt-[48px]">
        <section className="py-16 md:py-20">
          <div className="max-w-[700px] mx-auto px-5">
            <h1 className="font-noto-serif text-2xl md:text-3xl font-bold text-center mb-12">
              キャンセルポリシー
            </h1>

            <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm space-y-8">
              <div>
                <h2 className="font-bold text-base mb-3">受講開始前のキャンセル</h2>
                <p className="text-sm text-lp-charcoal-mid leading-relaxed">
                  受講開始日前のキャンセルは、書面またはメールでの通知により可能です。振込手数料の実費のみ控除した金額を全額返金いたします。
                </p>
              </div>

              <div>
                <h2 className="font-bold text-base mb-3">受講開始後のキャンセル</h2>
                <p className="text-sm text-lp-charcoal-mid leading-relaxed">
                  受講開始後のキャンセルによる返金はできません。あらかじめご了承ください。
                </p>
              </div>

              <div>
                <h2 className="font-bold text-base mb-3">システム継続プランの解約</h2>
                <p className="text-sm text-lp-charcoal-mid leading-relaxed">
                  システム継続プラン（月額19,800円）は、解約通知があるまで自動継続となります。前月末日までにご通知いただければ、翌月末での解約が可能です。
                </p>
              </div>

              <div>
                <h2 className="font-bold text-base mb-3">キャンセルのご連絡</h2>
                <p className="text-sm text-lp-charcoal-mid leading-relaxed">
                  キャンセルをご希望の場合は、お問い合わせフォームまたは書面にてご連絡ください。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <LPFooter />
    </div>
  );
};

export default CancellationPolicyPage;
